<template>
  <div v-if="casenotes" style="margin:10px 0">
    <b-card header-bg-variant="success"
            header-text-variant="white"
            header="Currently under investigation">
        <p class="card-text">&ldquo;{{ casenotes.notes }}&rdquo;</p>
        <b-link :to="`/alerts/${this.category}/${this.reference}/investigate`" class="card-link">View case notes</b-link>
        <template #footer>
            <small class="text-muted">Case created on {{ casenotes.created_at | moment('Do MMM YYYY HH:mm') }}</small>
        </template>
    </b-card>
  </div>
</template>

<script>
export default {
  props: ['casenotes', 'category', 'reference']
}
</script>
